import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const UndoIcon = (props) => {
  return (
 /*   <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="13"
      viewBox="0 0 36 25"
      width="20">
      <path class="st0" d="M11.7,8.1V6c0-0.8-0.9-1.3-1.5-0.8l-6.8,6c-0.5,0.4-0.5,1.2,0,1.6l6.8,6c0.6,0.5,1.5,0,1.5-0.8v-2h0.9  c7.1,0,13.5,4.3,16.5,11C29,16.8,21.3,8.6,11.7,8.1z"/>
     </svg>
*/
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="9.000000pt" height="9.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M0 2557 l0 -1127 1127 0 1128 0 -454 454 -453 454 53 42 c240 190
536 328 834 388 800 163 1620 -182 2070 -871 65 -100 162 -292 196 -389 13
-38 28 -68 32 -68 15 0 571 182 579 189 18 17 -140 372 -244 544 -80 135 -223
319 -349 451 -423 442 -961 712 -1579 791 -148 19 -461 22 -600 5 -510 -62
-958 -248 -1345 -560 -38 -31 -76 -60 -84 -65 -9 -5 -140 119 -462 441 l-449
449 0 -1128z"/>
</g>
</svg>

  );
};

export default UndoIcon;
